/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, Button, Checkbox, Form } from "semantic-ui-react";
import {
  updateBeneficiatioState,
  resetBeneficiarioState,
  getBeneficiario,
} from "@store/actions/index";
import AjaxLoader from "../shared/ajax_loader";
import CustomSnackbar from "../shared/custom_snackbar";
import ErrorMsgLabel from "../shared/errorMsgLabel";
import {
  dateDividers,
  getTodayDate,
  lastDayOfTheMonth,
  reverseMaskDate,
} from "@utils/date";
import m from "@utils/strings";
import _ from "lodash";
import "@styles/exames-procedimentos.css";

class FormAutorizacao extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      recemNascido: false,
      success: false,
      error: false,
      showLoader: false,
      disabled: false,
      beneficiarioDTO: {},
      hasSubmitted: false,
      isDateValid: true,
      isNumeroCarteiraEmpty: false,
    };

    this.focus = this.focus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleSetInitialFieldsState =
      this.handleSetInitialFieldsState.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.setInitialFieldsState(this.handleSetInitialFieldsState);
    this.props.focusFirstFieldAutorizacao(this.focus);
    this.props.validateAutorizacaoFields(this.handleSubmit);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleKeyDown(event) {
    if (
      event.key === "Enter" &&
      this.props.activeAccordion == "1" &&
      !this.state.success &&
      !this.props.beneficiario
    ) {
      event.preventDefault();
      this.handleSubmit();
    }
  }

  focus() {
    if (!this.state.disabled) {
      setTimeout(() => {
        if (this.textInput) this.textInput.focus();
      }, 1000);
    }
  }

  handleChange = (event) => {
    let target = event.target;
    let value = target.value.toString();
    let name = target.name;

    if (_.isEmpty(value)) {
      this.setState({ isNumeroCarteiraEmpty: true });
    } else {
      this.setState({ isNumeroCarteiraEmpty: false });
    }

    value = value.replace(
      /([.*+?^=!:;>,<"'´`~&%$#@${}()|\[\]\\a-zA-Z\/\-\_])/g,
      ""
    );
    this.setState({
      [name]: value,
    });
  };

  handleCheckboxChange = () => {
    this.setState({ recemNascido: !this.state.recemNascido });
  };

  dateChange = (event, { name, value }) => {
    let temp = reverseMaskDate(value, dateDividers.DASH, dateDividers.BAR);
    let splitDate = temp.split("/");

    if (splitDate.length === 3) {
      if (parseInt(splitDate[1], 10) > 12) splitDate[1] = "1";

      if (
        splitDate[1].length > 0 &&
        parseInt(splitDate[0], 10) >
          lastDayOfTheMonth(parseInt(splitDate[1], 10))
      )
        splitDate[0] = "1";
      if (splitDate[2].length <= 4) {
        // value = splitDate[0] + "/" + splitDate[1] + "/" + splitDate[2];
        this.setState({ [name]: value });
      }
      if (
        splitDate[2].length === 4 &&
        new Date(`${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`) > new Date()
      ) {
        this.dataMaior();
        this.setState({ [name]: reverseMaskDate(getTodayDate()) });
      }
    } else if (splitDate.length > 3) {
    } else {
      this.setState({ [name]: value });
    }

    if (
      splitDate.length === 3 &&
      splitDate[0].length > 0 &&
      splitDate[1].length > 0 &&
      splitDate[2].length > 0 &&
      !this.isDateValid(splitDate)
    ) {
      this.setState({ isDateValid: false });
    } else {
      this.setState({ isDateValid: true });
    }
  };

  buildBeneficiarioParams = (date) => {
    const { willAuthorize, prestador, tipoAtendimento } = this.props;

    const beneficiarioDTO = {
      CNPJPrestador: prestador.CPF_CNPJ,
      NomePrestador: prestador.Nome,
      NumeroCarteiraBeneficiario: this.state.numeroCarteira,
      NomeBeneficiario: "USUARIO GENERICO",
      CartaoNacionalSaude: "",
      DataAtual: date,
      HoraAtual: "",
      RecemNascido: this.state.recemNascido,
      RegistroANS: "",
      willAuthorize: willAuthorize,
      TipoAtendimento: tipoAtendimento,
    };

    this.setState({ beneficiarioDTO: beneficiarioDTO });

    return beneficiarioDTO;
  };

  isDateValid = (date) => {
    if (
      date.length != 3 ||
      date[1].length === 0 ||
      date[0].length === 0 ||
      date[2].length === 0
    )
      return false;
    if (
      new Date(`${date[1]}/${date[0]}/${date[2]}`).toString() === "Invalid Date"
    )
      return false;
    return true;
  };

  handleSubmit(event) {
    this.props.setApiError(false, "");

    if (!this.state.hasSubmitted) {
      let date = reverseMaskDate(
        this.state.date,
        dateDividers.DASH,
        dateDividers.BAR
      ).split("/");
      if (!this.isDateValid(date) || date[2].length < 4) {
        this.setState({ isDateValid: false });
        return;
      } else {
        this.setState({ isDateValid: true });
      }

      if (_.isEmpty(this.state.numeroCarteira)) {
        this.setState({ isNumeroCarteiraEmpty: true });
        return;
      } else {
        this.setState({ isNumeroCarteiraEmpty: false });
      }

      if (this.state.isDateValid && !_.isEmpty(this.state.numeroCarteira)) {
        const params = this.buildBeneficiarioParams(
          new Date(`${date[1]}/${date[0]}/${date[2]}`)
        );
        this.setState({
          hasSubmitted: true,
          showLoader: !this.state.showLoader,
        });
        this.props.getBeneficiario(
          params,
          (result) => {
            this.setState({
              hasSubmitted: false,
              showLoader: !this.state.showLoader,
            });
            this.handleSubmitResult(result);
          },
          (error) => {
            this.setState({
              hasSubmitted: false,
              showLoader: !this.state.showLoader,
            });
            if (this.props.onEligibilitySubmit != null) {
              this.props.onEligibilitySubmit(error);
              return;
            }
            this.props.callSnackbarFailure(
              m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_COMUNICACAO_SERVICO
            );
            this.props.setApiError(true, error);
            this.props.closeAllAccordions();
          }
        );
      }
    }
  }

  handleSubmitResult = (result) => {
    if ((result?.data?.Elegibilidade?.CodigoMotivoNegativa ?? "").length > 0) {
      this.props.setApiError(
        true,
        `${result.data.Elegibilidade.CodigoMotivoNegativa} - ${result.data.Elegibilidade.DescricaoMotivoNegativa}`
      );
    } else {
      this.props.updateBeneficiatioState(result);
      const {
        data: { Elegibilidade: Elegibilidade },
      } = result;
      if (Elegibilidade.IndicadorElegibilidade === "S") {
        this.props.callSnackbarSucess();
        this.setState({
          success: true,
          error: false,
          disabled: true,
        });
        this.props.openNextAccordion();
        this.props.updateDadosBeneficiario({
          beneficiarioDTO: this.state.beneficiarioDTO,
        });
        if (this.props.onEligibilitySubmit == null) return;
        this.props.onEligibilitySubmit(null, result);
      } else {
        this.props.blockAllAccordions();
        this.props.closeAllAccordions();
        this.setState({
          error: true,
          success: true,
          disabled: true,
        });
        if (this.props.onEligibilitySubmit == null) return;
        this.props.onEligibilitySubmit("API ERROR");
      }
    }
  };

  handleSetInitialFieldsState = () => {
    this.setState({
      date: reverseMaskDate(getTodayDate()),
      numeroCarteira: "",
      recemNascido: false,
      success: false,
      error: false,
      showLoader: false,
      disabled: false,
      beneficiarioDTO: {},
      hasSubmitted: false,
      isNumeroCarteiraEmpty: false,
    });
  };

  render() {
    const { beneficiario } = this.props;

    const fieldClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.error && beneficiario ? "error" : ""}`;

    const numeroCarteiraClassName = `${
      this.state.success && beneficiario ? "success" : ""
    } 
            ${this.state.isNumeroCarteiraEmpty ? "error" : ""}
            ${this.state.disabled && beneficiario ? "disabled" : ""}`;

    const btnAutorizarClassName = `btn-default-cemig`;

    const loader = this.state.showLoader ? <AjaxLoader /> : "";

    if (this.state.numeroCarteira.length > 17)
      this.setState({ numeroCarteira: this.state.numeroCarteira.slice(0, 17) });

    return (
      <div className={"form-accordion"}>
        {loader}
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Field
              inline={true}
              className={fieldClassName}
              width={10}
              disabled={this.state.success && beneficiario ? true : false}
            >
              <div>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_DATA_ATENDIMENTO}
                </label>
              </div>
              <div className={"div-date-input"}>
                <Input
                  type="date"
                  style={{ width: 312 }}
                  name="date"
                  value={this.state.date}
                  className={this.state.isDateValid ? "" : "error"}
                  iconPosition="left"
                  // closable={true}
                  onChange={this.dateChange}
                />
              </div>
              <ErrorMsgLabel
                boolean={!this.state.isDateValid}
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_DATA_INVALIDA}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field
              inline={true}
              className={numeroCarteiraClassName}
              disabled={this.state.success && beneficiario ? true : false}
            >
              <div className={"div-separador-top"}>
                <label className={"form-autorizacao-label"}>
                  {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_NUMERO_CARTEIRA}
                </label>
              </div>
              <Input
                style={{ width: 312 }}
                className={this.state.isNumeroCarteiraEmpty ? "error " : ""}
                name="numeroCarteira"
                icon="id card"
                ref={(input) => {
                  this.textInput = input;
                }}
                iconPosition="left"
                value={this.state.numeroCarteira}
                onChange={this.handleChange}
              />
              <ErrorMsgLabel
                boolean={this.state.isNumeroCarteiraEmpty}
                message={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_CAMPO_OBRIGATORIO}
              />
            </Form.Field>
            <Form.Field
              inline={true}
              className={fieldClassName}
              disabled={this.state.success && beneficiario ? true : false}
            >
              <Checkbox
                name="recemNascido"
                label={m.TELA_EXAMES_PROCEDIMENTOS.LABEL_RECEM_NASCIDO}
                type="checkbox"
                style={{ marginTop: 30, fontFamily: "Work Sans" }}
                checked={this.state.recemNascido}
                onChange={this.handleCheckboxChange}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field
              inline={true}
              width={10}
              disabled={this.state.success && beneficiario ? true : false}
            >
              <Button type="submit" className={btnAutorizarClassName}>
                {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_VERIFICAR} (ENTER)
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
        <CustomSnackbar
          setClick={(click) => (this.dataMaior = click)}
          variant="warning"
          duration={2000}
          content={m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_DATA_MENOR}
        />
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  /*
    if (!values.numero_carteira || values.numero_carteira.length < 17) {
        errors.numero_carteira = "Por favor, digite apenas números!"
    }
    */
  return errors;
}

export default connect(null, {
  updateBeneficiatioState,
  resetBeneficiarioState,
  getBeneficiario,
})(FormAutorizacao);
